export default __webpack_public_path__ + "static/media/makeindia.d5df8387.png";